import { isConnectedAccount } from 'owa-accounts-store';
import { getConnectedAccountHeaders } from './getDefaultRequestHeaders';
import { createRestApiRequestHeadersWithFetchOptions } from './createRestApiRequestHeadersWithFetchOptions';

export function createRestApiRequestHeaders(primarySmtpAddress: string = null): Promise<void | {}> {
    let headers = {};

    if (isConnectedAccount(primarySmtpAddress)) {
        headers = createRestApiRequestHeadersWithFetchOptions();
        const authHeaders = getConnectedAccountHeaders(primarySmtpAddress);

        // Merge the connected account headers with the rest api request headers
        return authHeaders.then(authHeaders => {
            Object.keys(authHeaders).forEach(
                headerName => (headers[headerName] = authHeaders[headerName])
            );

            return headers;
        });
    } else {
        return Promise.resolve(headers);
    }
}
